// extracted by mini-css-extract-plugin
export default {"notification":"aIhi8DzvnC","small":"_2BQJQgSjGR","icon":"_3S9GMdVP7L","container":"_3gCo73TuWY","with-details":"_3AwxzLy85k","withDetails":"_3AwxzLy85k","error":"_2-7Cd0Iw_u","warning":"x5E0WEYBBL","info":"ayISXFt3yl","success":"_3o9ywFYlKI","title":"_1vr0xHNESC","content":"_3TxuFPvF2Z"};
    if(module.hot) {
      // 1633091598052
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  